import AuthenticationPayload from "./AuthenticationPayload";
import Api from "../Api";
import HttpClient from "../HttpClient";
import AuthenticationResult from "./AuthenticationResult";

// noinspection JSUnusedGlobalSymbols
class AuthenticationApi {
    /**
     * Authenticates user and returns response.
     * @param p AuthenticationPayload
     * @returns AuthenticationResult or error
     * @author Kacper Faber
     * @since 0.1.0
     */
    static authenticate(p: AuthenticationPayload): Promise<AuthenticationResult> {
        const url = Api.getUrl('/api/auth/');
        return HttpClient.post<AuthenticationResult>(url, {}, {...p});
    }
}

// noinspection JSUnusedGlobalSymbols
export default AuthenticationApi;